<template>
  <v-container
    id="error-view"
    class="fill-height text-center"
    tag="section"
  >
    <v-row justify="center">
      <v-col cols="auto">
        <div class="text-h4 pt-8 pb-10">
          {{ $t(error.message) }}
        </div>

        <v-btn
          depressed
          large
          :to=" error ? error.to : '/'"
        >
          {{ $t(error.btn_text) }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'ErrorView',
    data: function () {
      return {
        errors: [
          { message: 'Page not found :(', to: '/', btn_text: 'back_to_the_dashboard' },
          { message: 'no_aircraft_available', to: '/planes', btn_text: 'back_to_the_planes' },
          { message: 'no_rentable_aircraft_available', to: '/', btn_text: 'back_to_the_dashboard' },
        ],
      }
    },
    computed: {
      error () {
        return this.errors.filter(h => h.message === this.$route.params.message)[0] ?? this.errors[0]
      },
    },
    mounted () {
      this.message = this.$route.params.message
    },
  }
</script>

<style lang="sass">
  #error-view h1.text-h1
    font-size: 14rem !important
</style>
